import React, { useRef, useState } from "react";
import styles from "./SpaceGuideCardTitle.module.scss";
import IconTitleBox from "../../common/IconTitleBox/IconTitleBox";

const SpaceGuideCardTitle = ({ item }) => {
  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <section className={styles.card__infobox}>
          <span className={styles.card__title}>{item.title}</span>
          <p className={styles.card__desc}>{item.desc}</p>
          <div className={styles.iconList}>
            {item.iconData?.map((item) => {
              return <IconTitleBox key={item} item={item} />;
            })}
          </div>
        </section>
      </div>
    </div>
  );
};

export default SpaceGuideCardTitle;
